import { Fragment, startTransition, useEffect } from "react";
import { getCaresShellBootstrap } from "../components/cares/shell/bootstrap";
import { data$, getState, setAttributes, setState } from "../shared/services/switcherServices";

const getPreferredThemeMode = (): "dark" | "light" => {
  const storedTheme = window.localStorage.getItem("caresThemeMode");
  if (storedTheme === "dark" || storedTheme === "light") {
    return storedTheme;
  }

  if (window.localStorage.getItem("udondarkTheme")) {
    return "dark";
  }

  if (window.localStorage.getItem("udonlightTheme")) {
    return "light";
  }

  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

function RootWrapper({ children }: any) {
  useEffect(() => {
    const bootstrap = getCaresShellBootstrap();
    const preferredThemeMode = getPreferredThemeMode();
    const mobileSidebarToggleState = window.innerWidth <= 992 ? "close" : getState().toggled;

    if (bootstrap.themeDefaults && Object.keys(bootstrap.themeDefaults).length > 0) {
      startTransition(() => {
        setState({
          ...bootstrap.themeDefaults,
          dataThemeMode: preferredThemeMode,
          dataHeaderStyles: preferredThemeMode,
          dataMenuStyles: preferredThemeMode,
          toggled: bootstrap.themeDefaults.toggled && bootstrap.themeDefaults.toggled !== ""
            ? bootstrap.themeDefaults.toggled
            : mobileSidebarToggleState,
        });
      });
    }

    // Subscribe to state changes
    const subscription = data$.subscribe(() => {
      setAttributes(); // Update <html> attributes when state changes
    });
    // Initial attribute setup
    setAttributes();

    const preferenceController = new AbortController();
    fetch('/api/v1/secure/profile/schedule-view-preferences', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: preferenceController.signal,
    }).then(response => response.ok ? response.json() : null).then(payload => {
      const theme = payload?.theme_options;
      if (!theme) return;
      startTransition(() => setState({
        dataThemeMode: theme.mode,
        dataHeaderStyles: theme.mode,
        dataMenuStyles: theme.mode,
        dataNavLayout: theme.navigation_layout,
        dataVerticalStyle: theme.navigation_layout === 'vertical' ? 'overlay' : '',
        dataNavStyle: theme.navigation_layout === 'horizontal' ? 'menu-click' : '',
        dataPageStyle: theme.page_style,
        dataWidth: theme.width,
        colorPrimaryRgb: theme.primary_rgb,
      }));
    }).catch(() => undefined);

    // Cleanup subscription on unmount
    return () => { preferenceController.abort(); subscription.unsubscribe(); };
  }, []);

  return <Fragment>{children}</Fragment>;
}

export default RootWrapper;
